<template>
  <div>
    <!-- <v-row align="center" justify="start">
      <h4 class="text-left">Dirección:</h4>
    </v-row> -->
    <v-row class="d-flex mb-6">
      <v-icon>mdi-map-marker</v-icon>
      <gmap-autocomplete
        @place_changed="setPlace"
        placeholder="Escribe aquí tu dirección"
      >
      </gmap-autocomplete>
    </v-row>

    <GmapMap
      :center="coordenadasCenterMap"
      :zoom="16"
      map-type-id="terrain"
      style="width: 100%; height: 300px"
      ref="mapRef"
      :options="{
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
      }"
    >
      <GmapMarker
        :position.sync="formOkBoy.coordenadasMap"
        :clickable="true"
        :draggable="true"
        @dragend="updateMaker"
      ></GmapMarker>
    </GmapMap>
    <small>
      <p>
        {{
          formOkBoy.address.street +
          " " +
          formOkBoy.address.numExt +
          " " +
          formOkBoy.address.suburb +
          " " +
          formOkBoy.address.municipality +
          " " +
          formOkBoy.address.state +
          " " +
          formOkBoy.address.zipcode
        }}
      </p>
    </small>
  </div>
</template>

<script>
import Axios from "axios";
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields([
      "formOkBoy",
      "coverageFlag",
      "coordenadasCenterMap",
      "coordenadasMarker",
      "showMessage",
      "message",
    ]),
  },
  data() {
    return {
      // coordenadasMarker: {
      //   lat: null,
      //   lng: null,
      // },
    };
  },
  methods: {
    setPlace(place) {
      this.coverageFlag = false;
      this.currentPlace = place;
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        // this.coordenadasMarker = marker;
        this.formOkBoy.coordenadasMap = marker;
        this.coordenadasCenterMap = marker;
      }
      this.searchAddess(place.address_components);
    },
    updateMaker: function (event) {
      this.coverageFlag = false;
      let lat = event.latLng.lat();
      let lng = event.latLng.lng();
      this.formOkBoy.coordenadasMap = {
        lat: lat,
        lng: lng,
      };
      this.getAddress(lat, lng);
      // this.markers[0].position = {
      //     lat: event.latLng.lat(),
      //     lng: event.latLng.lng(),
      // }
    },
    getAddress(lat, lng) {
      let api = Axios.get(
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
          lat +
          "," +
          lng +
          "&key=AIzaSyD3Lt1KM-kDNRBpmtScC-sLtMBFu6BpM-k"
      )
        .then((response) => {
          this.searchAddess(response.data.results[0].address_components);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    searchAddess(Address) {
      this.formOkBoy.address.longitude = this.formOkBoy.coordenadasMap.lng.toString();
      this.formOkBoy.address.latitude = this.formOkBoy.coordenadasMap.lat.toString();
      for (let i = 0; i < Address.length; i++) {
        for(let j = 0; j < Address[i].types.length; j++) {
          switch (Address[i].types[j]) {
          case "street_number":
            this.formOkBoy.address.numExt = Address[i].long_name;
            break;
          case "route":
            this.formOkBoy.address.street = Address[i].long_name;
            break;
          case "sublocality_level_1":
            this.formOkBoy.address.suburb = Address[i].long_name;
            break;
          case "locality":
            this.formOkBoy.address.municipality = Address[i].long_name;
            break;
          case "administrative_area_level_1":
            this.formOkBoy.address.state = Address[i].long_name;
            break;
          case "postal_code":
            this.formOkBoy.address.zipcode = Address[i].long_name;
            break;0
        }
        }
      }
    },
  },
  // created() {
  //   this.$getLocation({})
  //     .then((coordinates) => {
  //       this.formOkBoy.coordenadasMap = coordinates;
  //       this.coordenadasCenterMap = coordinates;
  //       getAddress(coordinates.lat, coordinates.lng)
  //     })
  //     .catch((error) => {
  //       console.error(error)
  //       this.message = "Es necesaria la ubicación"
  //       this.showMessage = true;
  //     });
  // },
  mounted() {
    // this.$refs.mapRef.$mapPromise.then((map) => (this.map = map));
  },
};

window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
    'event': 'Pageview',
    'pagePath': 'https://okboy.app/address',
    'pageTitle': 'Customer Address Info'
  });
</script>

<style scoped>
.pac-target-input {
  height: 30px;
  width: 90%;
  outline-style: auto;
  outline-color: #929292;
  align-items: flex-start;
  display: flex;
  font-size: 16px;
  max-width: 100%;
  box-sizing: inherit;
      padding: 0 12px;
      background: transparent;
}
</style>